module.exports = __webpack_public_path__ + "img/audiosample.9433ded2.png";